export const destinations = [
  {
    id: 'bali',
    name: '巴厘岛',
    nameEn: 'Bali',
    category: 'southeast-asia',
    categoryName: '东南亚',
    description: '印度尼西亚的明珠，以绝美海滩、古老寺庙、梯田稻浪和独特的印度教文化闻名于世。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Bali%20beach%20with%20traditional%20temple%20gate%20and%20tropical%20palm%20trees%20against%20sunset%20sky%2C%20serene%20and%20dreamy%20travel%20photography%20style%2C%20warm%20golden%20light%2C%20clean%20composition%2C%20professional%20travel%20magazine%20quality&width=800&height=600&seq=bali-dest-01&orientation=landscape',
    highlights: ['海滩度假', '寺庙文化', '梯田景观', '冲浪天堂'],
    rating: 4.8,
    reviews: 12560,
  },
  {
    id: 'bangkok',
    name: '曼谷',
    nameEn: 'Bangkok',
    category: 'southeast-asia',
    categoryName: '东南亚',
    description: '泰国的活力之都，融合了金碧辉煌的皇宫寺庙与现代都市的繁华夜色，街头美食享誉全球。',
    image: 'https://readdy.ai/api/search-image?query=Grand%20Palace%20Bangkok%20Thailand%20with%20golden%20spires%20and%20intricate%20Thai%20architecture%20under%20bright%20blue%20sky%2C%20vibrant%20and%20cultural%20atmosphere%2C%20professional%20travel%20photography%20with%20warm%20tones%2C%20clean%20composition&width=800&height=600&seq=bangkok-dest-02&orientation=landscape',
    highlights: ['大皇宫', '水上市场', '街头美食', '夜市购物'],
    rating: 4.6,
    reviews: 15320,
  },
  {
    id: 'tokyo',
    name: '东京',
    nameEn: 'Tokyo',
    category: 'east-asia',
    categoryName: '东亚',
    description: '传统与现代完美交融的超级都市，从浅草寺的古韵到涩谷的霓虹，每一处都令人心动。',
    image: 'https://readdy.ai/api/search-image?query=Tokyo%20cityscape%20with%20cherry%20blossoms%20and%20traditional%20pagoda%20temple%20contrasted%20with%20modern%20skyscrapers%2C%20soft%20pink%20and%20warm%20light%2C%20dreamy%20spring%20atmosphere%2C%20professional%20travel%20photography%20quality&width=800&height=600&seq=tokyo-dest-03&orientation=landscape',
    highlights: ['樱花季', '浅草寺', '秋叶原', '美食天堂'],
    rating: 4.9,
    reviews: 18940,
  },
  {
    id: 'seoul',
    name: '首尔',
    nameEn: 'Seoul',
    category: 'east-asia',
    categoryName: '东亚',
    description: '韩国的活力心脏，古宫与K-pop文化并存，是购物、美食与文化探索的绝佳目的地。',
    image: 'https://readdy.ai/api/search-image?query=Gyeongbokgung%20Palace%20Seoul%20Korea%20with%20traditional%20colorful%20architecture%20and%20autumn%20maple%20trees%2C%20warm%20autumn%20tones%2C%20historic%20and%20cultural%20atmosphere%2C%20professional%20travel%20photography%20with%20clean%20composition&width=800&height=600&seq=seoul-dest-04&orientation=landscape',
    highlights: ['景福宫', '明洞购物', '韩流文化', '美食探店'],
    rating: 4.7,
    reviews: 11230,
  },
  {
    id: 'maldives',
    name: '马尔代夫',
    nameEn: 'Maldives',
    category: 'south-asia',
    categoryName: '南亚',
    description: '印度洋上的珍珠项链，水上别墅与碧蓝潟湖构成的人间天堂，是蜜月旅行的终极之选。',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20overwater%20villas%20in%20Maldives%20with%20crystal%20clear%20turquoise%20lagoon%20water%2C%20white%20sand%20beach%2C%20blue%20sky%20with%20fluffy%20clouds%2C%20tropical%20paradise%20atmosphere%2C%20professional%20travel%20photography%2C%20clean%20minimal%20composition&width=800&height=600&seq=maldives-dest-05&orientation=landscape',
    highlights: ['水上别墅', '潜水胜地', '蜜月天堂', '私岛度假'],
    rating: 4.9,
    reviews: 8970,
  },
  {
    id: 'sri-lanka',
    name: '斯里兰卡',
    nameEn: 'Sri Lanka',
    category: 'south-asia',
    categoryName: '南亚',
    description: '印度洋上的宝石，拥有古老佛教遗迹、高山茶园、野生动物保护区与迷人的海岸线。',
    image: 'https://readdy.ai/api/search-image?query=Sigiriya%20Lion%20Rock%20Sri%20Lanka%20ancient%20fortress%20surrounded%20by%20lush%20green%20jungle%2C%20dramatic%20landscape%2C%20warm%20tropical%20light%2C%20travel%20adventure%20photography%20style%2C%20professional%20quality%20with%20clean%20composition&width=800&height=600&seq=srilanka-dest-06&orientation=landscape',
    highlights: ['狮子岩', '高山茶园', '野生动物', '海上火车'],
    rating: 4.5,
    reviews: 6540,
  },
  {
    id: 'chiang-mai',
    name: '清迈',
    nameEn: 'Chiang Mai',
    category: 'southeast-asia',
    categoryName: '东南亚',
    description: '泰北玫瑰，古城寺庙林立，夜市热闹非凡，周边山林瀑布是户外爱好者的乐园。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Buddhist%20temple%20in%20Chiang%20Mai%20Thailand%20with%20golden%20pagoda%20and%20lush%20green%20mountains%20background%2C%20serene%20and%20peaceful%20atmosphere%2C%20warm%20morning%20light%2C%20professional%20travel%20photography%2C%20clean%20composition&width=800&height=600&seq=chiangmai-dest-07&orientation=landscape',
    highlights: ['古城寺庙', '夜市文化', '丛林飞跃', '手工艺村'],
    rating: 4.7,
    reviews: 9820,
  },
  {
    id: 'kyoto',
    name: '京都',
    nameEn: 'Kyoto',
    category: 'east-asia',
    categoryName: '东亚',
    description: '日本千年古都，遍布神社寺庙与精致庭园，在枫叶与樱花季更是美不胜收。',
    image: 'https://readdy.ai/api/search-image?query=Fushimi%20Inari%20Shrine%20Kyoto%20Japan%20with%20thousands%20of%20red%20torii%20gates%20path%20through%20forest%2C%20mystical%20and%20cultural%20atmosphere%2C%20soft%20natural%20light%2C%20professional%20travel%20photography%2C%20clean%20balanced%20composition&width=800&height=600&seq=kyoto-dest-08&orientation=landscape',
    highlights: ['伏见稻荷', '金阁寺', '岚山竹林', '抹茶体验'],
    rating: 4.9,
    reviews: 21450,
  },
  {
    id: 'nepal',
    name: '尼泊尔',
    nameEn: 'Nepal',
    category: 'south-asia',
    categoryName: '南亚',
    description: '喜马拉雅山脚下的神秘国度，是徒步爱好者的天堂，也是佛教与印度教文化的交汇之地。',
    image: 'https://readdy.ai/api/search-image?query=Himalayan%20mountain%20range%20with%20snow%20peaks%20and%20colorful%20prayer%20flags%20in%20Nepal%2C%20traditional%20stone%20village%20in%20foreground%2C%20dramatic%20landscape%2C%20clear%20blue%20sky%2C%20adventure%20travel%20photography%2C%20professional%20quality%20with%20clean%20composition&width=800&height=600&seq=nepal-dest-09&orientation=landscape',
    highlights: ['喜马拉雅', '徒步天堂', '佛教圣地', '加德满都'],
    rating: 4.6,
    reviews: 7890,
  },
];

export const getDestinationsByCategory = (categorySlug: string) => {
  return destinations.filter(d => d.category === categorySlug);
};

export const getDestinationById = (id: string) => {
  return destinations.find(d => d.id === id) || null;
};